/* eslint-disable react/prop-types */
/* eslint-disable import/no-unresolved */
/* eslint-disable global-require */
/* eslint-disable  */
import React, { lazy, useEffect } from 'react';

import { useCookies } from 'react-cookie';
import { useNavigate } from 'react-router-dom';
import appNav from './appNav';
import Loader from '../components/Loader/Loader';

const Main = lazy(() => import('../screens/Main'));

const PrivateRoute = ({ as: Component, ...props }) => {
  const [cookies] = useCookies();
  const navigate = useNavigate();
  const [auth, setAuth] = React.useState(false);
  useEffect(() => {
    if (false) {
      navigate('../login');
      setAuth(false);
    } else {
      setAuth(true);
    }
  }, [cookies.token, navigate]);

  return auth ? <Component {...props} /> : <Loader />;
};

const appRoutes = [
  {
    path: 'app',
    element: <PrivateRoute as={Main} />,
    children: appNav,
  },
];

export default appRoutes;
